import React from 'react';
import type {ThesaurusNodeDetailsDateValue as GrepDetailsDateValueType} from 'services/thesaurus/types';
import {useLocalization} from 'localization';
import {FlexBox} from 'components/layout';
import {Text} from 'components/text';
import {NodeLabel} from './NodeLabel';

type Props = {
  itemKey: string;
  value: GrepDetailsDateValueType;
};

export const GrepDetailsDateValue: React.FC<Props> = ({itemKey, value}) => {
  const {formatDate} = useLocalization();

  return (
    <FlexBox>
      <NodeLabel label={itemKey} />
      <Text kind="primary" variant="body2">
        {formatDate(value.value)}
      </Text>
    </FlexBox>
  );
};
